import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
export const getPipelines = async ({ client }) => {
    const data = await client.pim.request(graphql(`
      query GET_PIPELINES($tenantId: ID!) {
        pipeline {
          getMany(tenantId: $tenantId) {
            edges {
              node {
                id
                name
                stages {
                  id
                  name
                }
              }
            }
          }
        }
      }
    `), { tenantId: client.tenantId });
    if (!data)
        throw new Error(`Failed to retrieve pipelines for tenant: ${client.tenantId}`);
    return data;
};
